import AppIcon from "@/common/components/Icons/AppIcon";
import { useApiRequest } from "@/common/hooks/api/useApiRequest";
import { apiClient } from "@/core/api/ApiClient";
import { VehicleVisualModelDto, VehicleVisualModelReferenceDto } from "@/core/api/generated/v1";

import BaseEntityInline, {
  BaseEntityInlineInheritableProps,
} from "../components/EntityInline/BaseEntityInline";
import { getVehicleVisualModelOptionTitle } from "./VehicleVisualModelAutocomplete";

export interface VehicleVisualModelInlineProps extends BaseEntityInlineInheritableProps {
  entity: VehicleVisualModelDto | VehicleVisualModelReferenceDto | null | undefined;
  entityId?: string | null;
}

export default function VehicleVisualModelInline({
  entity,
  entityId,
  ...otherProps
}: VehicleVisualModelInlineProps) {
  const request = useApiRequest(
    apiClient.vehicleVisualModelsApi.apiV1ReferenceDataVehiclesVisualModelsModelIdGet,
    {
      modelId: entityId!,
    },
    {
      deps: [entityId],
      skip: !entityId || !!entity,
    },
  );
  entity = request?.data || entity;

  const full = entity as VehicleVisualModelDto;
  // const ref = entity as VehicleVisualModelReferenceDto;

  return (
    <BaseEntityInline
      entity={entity}
      entityId={entityId}
      request={request}
      icon={<AppIcon of='vehicleVisualModel' inText />}
      content={<>{full && getVehicleVisualModelOptionTitle(full)}</>}
      {...otherProps}
      tooltipTitle={otherProps?.tooltipTitle || "Vehicle visual model"}
    />
  );
}
